<template>
	<div class="error-page">
		<GlobalHeader booker />
		<div class="error-page__container">
			<div class="error-page__content">
				<div v-if="error.statusCode === 404">{{ $t('common.error_pate.not_found') }}</div>
				<div>{{ $t('common.error_pate.error_occurred') }} - {{ error.statusCode }}</div>
				<NuxtLink :to="localePath('/')">
					<ButtonPrimary>{{ $t('common.error_pate.go_back') }}</ButtonPrimary>
				</NuxtLink>
			</div>
		</div>
		<LazyVisibleGlobalFooter hydrate-on-visible />
	</div>
</template>

<script setup lang="ts">
const localePath = useLocalePath()

const props = defineProps({
	error: {
		type: Object,
		required: true,
	},
})
logger.log(props.error)
useHead(pageHead.COMMON.ERROR)
usePageViewed(Number(props.error.statusCode) === 404 ? EGTMPageType.NOT_FOUND : EGTMPageType.ERROR)
</script>

<style lang="scss" scoped>
.error-page {
	& &__container {
		display: flex;
		align-items: center;
		justify-content: center;
		min-height: 80vh;
		overflow: hidden;
		padding-inline: 16px;
		padding-block: 16px;
		background-color: var(--background-color);
	}

	& &__content {
		display: flex;
		gap: 24px;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 72px;
		padding-inline: 16px;
		text-align: center;
		font-size: 32px;
		font-weight: 500;
		line-height: 100%;
	}
}
</style>
